module.exports = __webpack_public_path__ + "static/media/menu_cancellationPolicy_hoverActive.e67746eb.svg";